import { SampleRequestConfigurationData } from '@ysura/common';

import { parseTemplateData } from '@/services/graphql/parsers';
import {
  SampleRequestConfiguration,
  SampleRequestConfigurationConnection,
} from '@/services/graphql/types';
import { DeepPartial } from '@/types/data';
import { filterNonNull } from '@/utils/dataHelpers/filters';

export const parseSampleRequestConfigurationData = (
  sampleRequest?: DeepPartial<SampleRequestConfiguration>
): SampleRequestConfigurationData => {
  return {
    id: sampleRequest?.id,
    oid: sampleRequest?.oid,
    name: sampleRequest?.name ?? undefined,
    customerReference: sampleRequest?.customerReference ?? undefined,
    title: sampleRequest?.title ?? undefined,
    displayNoSamplesSelected:
      sampleRequest?.displayNoSamplesSelected ?? undefined,
    displayPhysicalSamples: sampleRequest?.displayPhysicalSamples ?? undefined,
    displayVirtualSamples: sampleRequest?.displayVirtualSamples ?? undefined,
    displayPhysicalAndVirtualSamples:
      sampleRequest?.displayPhysicalAndVirtualSamples ?? undefined,
    sampleRequestAdditionalDeliveryInformationEnabled:
      sampleRequest?.sampleRequestAdditionalDeliveryInformationEnabled ??
      undefined,
    sampleRequestDeliveryDateEnabled:
      sampleRequest?.sampleRequestDeliveryDateEnabled ?? undefined,
    sampleRequestDeliveryDateMinimumDaysInFuture:
      sampleRequest?.sampleRequestDeliveryDateMinimumDaysInFuture ?? undefined,
    template: sampleRequest?.template
      ? parseTemplateData(sampleRequest.template)
      : undefined,
  };
};

export const parseSampleRequestConfigurationsConnection = (
  sampleRequestConnection: DeepPartial<SampleRequestConfigurationConnection>
): Array<SampleRequestConfigurationData> => {
  const rawSampleRequests = sampleRequestConnection?.edges ?? [];
  const parsedSampleRequests = rawSampleRequests
    .map((edge) => edge?.node ?? null)
    .map((parsedSampleRequest) =>
      parsedSampleRequest
        ? parseSampleRequestConfigurationData(parsedSampleRequest)
        : null
    );

  return filterNonNull(parsedSampleRequests);
};
